<template>
    <div>
        <!--  :quicklinks= "can('orders.edit') ? $config('screen.evictionQuicklinks') : [] "
              :filters="can('orders.edit') ? filters : []"
        -->
        <psi-toolbar
            title="Evictions"
            :indicator="evictions.length"
            color="accent"
            :filters="[]"
            :quicklinks="[]"
            :actions="$config('screen.evictionActions')"
            :showActionMenu="selectedItems.length > 0"
            :view-option.sync="viewOption"
            @filter-item="filterItem"
            @filter-clear-all="filterClearAll"
            @quicklink-action="quicklinkAction"
            @action="toolbarAction"
            filter-label-class="accent white--text text-subtitle-2"
            hide-refresh
            close-on-select
            close-on-clear
        ></psi-toolbar>
        <keep-alive>
            <component
                :evictions="filteredEvictions"
                :is="`screen-evictions-${viewOption}`"
                :mode="mode"
                @item-selected="itemSelected"
                @toggle-select-all="toggleSelectAll"
                @exclude="$emit('exclude', $event)"
            ></component>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "screen-evictions-wrapper",
    props: {
        evictions: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "print",
        }
    },
    components: {
        ScreenEvictionsList: () => import("./ScreenEvictionsList"),
        ScreenEvictionsGrid: () => import("./ScreenEvictionsGrid"),
    },
    data() {
        return {
            selectedItems: [],
            filteredEvictions: this.evictions,
            filters: this.$config("screen.evictionFilters"),
            viewOption: "grid", // this.$vuetify.breakpoint.mobile ? "grid" : "list",
        };
    },
    methods: {
        itemSelected({ item, value }) {
            if (value) {
                // selected an item
                this.selectedItems.push(item);
            } else {
                // removed an item
                this.selectedItems.splice(
                    this.selectedItems.findIndex((elem) => elem.id === item.id),
                    1
                );
            }
        },
        toggleSelectAll({ items, value }) {
            if (value) {
                this.selectedItems = items;
            } else {
                this.selectedItems = [];
            }
        },
        quicklinkAction(event) {
            switch (event.title) {
                // TODO: change from title based to name based
                case "Matched":
                    // Clear out any set filters
                    this.resetFilters();
                    // Add only this filter from the quicklink
                    this.updateFilter("matched", "Matched", "value");
                    // Get the result data
                    this.filterData();
                    break;
            }
        },
        toolbarAction(event) {
            let evictionRecordIds = [];
            switch (event.slug) {
                case "delete-evictions":
                    evictionRecordIds = this.selectedItems.map(
                        (item) => item.id
                    );
                    // this.deleteMultipleEvictions(evictionRecordIds);
                    console.log(evictionRecordIds);
                    this.selectedItems = [];
                    break;
            }
        },
        /**
         * Run the result from the filter
         */
        filterData() {
            const filters = this.getFilter();
            console.log(filters);

            this.filteredEvictions = this.filteredEvictions.filter((item) => {
                let include = true;
                if (this.$_.has(filters, "matched")) {
                    include = item.matched === filters.matched.value;
                }
                if (this.$_.has(filters, "source")) {
                    include = item.source === filters.source.value;
                }
                return include;
            });
        },
        // get a filter structure for the given filters with values
        getFilter() {
            let filter = {};
            this.filters.forEach((item) => {
                if (this.$_.get(item, "value", "").toString().length) {
                    filter[item.name] = {
                        value: this.$_.get(item, "value", ""),
                    };
                }
            });
            return filter;
        },
        // Reset Filters to default values
        resetFilters() {
            this.filters.forEach((item) => {
                this.updateFilter(item.name, item.default, "value");
            });
        },
        // update a filter item value on the filters data
        updateFilter(filterName, data, key = "items") {
            const index = this.filters.findIndex(
                (item) => item.name == filterName
            );
            if (index !== -1) {
                let filter = this.filters[index];
                filter[key] = data;
                this.filters.splice(index, 1, filter);
            }
        },
        // set a given item to a filter value
        filterItem(item) {
            this.updateFilter(item.name, item.value, "value");
            this.filterData();
        },
        filterClearAll() {
            this.resetFilters();
            this.filterData();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>